<template>
  <ModalContainer class="basic-modal">
    <Card class="modal-content mx-auto">
      <div class="mdl-card__title typography--color-primary typography--font-weight-500 basic-modal-header" v-html="title">
      </div>

      <div class="mdl-card__supporting-text mdl-typography--body-1 basic-modal-body" v-if="!hideBody">
        <slot>body</slot>
      </div>

      <div class="mdl-card__actions text-right basic-modal-actions">
        <button class="mdl-button mdl-button--primary mdl-js-button mdl-js-ripple-effect"
                v-on:click="$emit('cancel')"
                v-if="!hideCancel"
                v-mdl>
          취소
        </button>
        <button class="mdl-button mdl-button--primary mdl-js-button mdl-js-ripple-effect"
                v-on:click="$emit('ok')"
                v-bind:disabled="okDisabled"
                v-mdl>
          확인
        </button>
      </div>
    </Card>
  </ModalContainer>
</template>

<script>
  export default {
    name: 'basic-modal',

    props: {
      title: {
        type: String,
        default: 'Title',
      },
      hideCancel: {
        type: Boolean,
        default: false,
      },
      hideBody: {
        type: Boolean,
        default: false,
      },
      okDisabled: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss">
  .basic-modal {
    .mdl-card {
      width: 285px;
      min-height: 0px;
    }

    .basic-modal-header {
      padding: 24px 24px 6px;
      font-size: 16px;
      line-height: 23px;
    }

    .basic-modal-body {
      padding: 6px 24px;
      min-height: 51px;
    }

    .basic-modal-actions {
      .mdl-button {
        font-size: 15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// BasicModal.vue?292fa4cc